// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeletons_skeleton__9TMqn","skeleton-loading":"Skeletons_skeleton-loading__hdRyo"};